import { ClusteredMarkerLayer } from '../Layers/ClusteredMarkersLayer';
import type { ClusteredMarkerLayerOptions } from '../Layers/Layers.types';
import RoadConditionMessage from '../PopupTemplates/RoadConditionMessage';
import { RoadConditionMessageSource } from '../Sources/RoadConditionMessage';

export const roadConditionMessage = function (region: string, options?: ClusteredMarkerLayerOptions): ClusteredMarkerLayer {
    const defaultOptions: ClusteredMarkerLayerOptions = {
        name: 'Väglagsvarning',
        itemPlural: 'väglagsvarningar',
        popupTemplate: RoadConditionMessage,
        source: new RoadConditionMessageSource(region, {
            updateInterval: 60,
        }),
        persistentInformationLayer: false,
        defaultIconId: 107,
    };

    return new ClusteredMarkerLayer({ ...defaultOptions, ...options });
};
